import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITooltip } from 'src/app/interfaces/itooltip';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
  standalone: false
})
export class CustomTooltipComponent implements OnInit {
  arrowDirection: string = 'top';
  heading: string = '';
  paragraph: string = '';
  backgroundColor: string = '#027B8C';
  fontColor: string = '#FFFFFF';
  contentWidth: string = 'auto';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ITooltip,
    public dialogRef: MatDialogRef<CustomTooltipComponent>
  ) { }

  ngOnInit() {
    this.arrowDirection = this.data?.arrowPosition;
    this.heading = this.data?.heading;
    this.paragraph = this.data?.paragraph;
    this.backgroundColor = this.data?.backgroundColor
    this.fontColor = this.data?.fontColor;
    this.contentWidth = this.data?.contentWidth;
  }
  ngAfterViewInit() {

    const modalContainer = document.querySelector('.tooltip-dialog-container .mat-mdc-dialog-container');

    if (modalContainer) {
      const rect = modalContainer.getBoundingClientRect();
      const arrow = document.createElement('div');
      arrow.style.position = 'absolute';
      arrow.style.borderWidth = '10px';
      arrow.style.borderStyle = 'solid';

      // Determine direction based on a data attribute or class
      const direction = this.arrowDirection;
      console.log('direction', direction);

      switch (direction) {
        case 'left':
          arrow.style.borderColor = `transparent ${this.backgroundColor} transparent transparent`;
          arrow.style.top = `${rect.top + rect.height / 2}px`;
          arrow.style.left = `${rect.left - 20}px`;
          arrow.style.transform = 'translateY(-50%)';
          break;

        case 'right':
          arrow.style.borderColor = `transparent transparent transparent ${this.backgroundColor}`;
          arrow.style.top = `${rect.top + rect.height / 2}px`;
          arrow.style.left = `${rect.right}px`;
          arrow.style.transform = 'translateY(-50%)';
          break;

        case 'top':
          arrow.style.borderColor = `transparent transparent ${this.backgroundColor} transparent`;
          arrow.style.left = `${rect.left + rect.width / 2}px`;
          arrow.style.top = `${rect.top - 20}px`;
          arrow.style.transform = 'translateX(-50%)';
          break;

        case 'bottom':
          arrow.style.borderColor = `${this.backgroundColor} transparent transparent transparent`;
          arrow.style.left = `${rect.left + rect.width / 2}px`;
          arrow.style.top = `${rect.bottom}px`;
          arrow.style.transform = 'translateX(-50%)';
          break;
      }
      modalContainer.appendChild(arrow);
    }
  }
}